import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import type { JSX } from 'react';
import { type HeadlessLinkProps, headlessLinkProps } from '../TextLink';
import styles from './LinkButton.module.css';
function LinkButton(props) {
  const $ = _c(6);
  let headlessProps;
  let t0;
  if ($[0] !== props) {
    const {
      className,
      ...t1
    } = headlessLinkProps(props);
    headlessProps = t1;
    t0 = classNames(styles.button, className);
    $[0] = props;
    $[1] = headlessProps;
    $[2] = t0;
  } else {
    headlessProps = $[1];
    t0 = $[2];
  }
  let t1;
  if ($[3] !== headlessProps || $[4] !== t0) {
    t1 = <button className={t0} {...headlessProps} />;
    $[3] = headlessProps;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export default LinkButton;